import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
// Formik
import { Formik } from 'formik';
import * as Yup from 'yup';
// CSS
import '../SignUp/SignUp.css';
import './SignIn.css';
//
import Button from '../../components/Button';
import Input from '../../components/Input';
import InputPassword from 'container/components/InputPassword';
import ErrorMessage from 'container/components/ErrorMessage';
import Spinner from 'container/components/Spinner';
import GoogleLogin from 'container/components/GoogleLogin/GoogleLogin';
import styled from 'styled-components';
// import SalesBanner from 'container/components/SalesBanner/SalesBanner';
// import { bannerText } from 'app.config';

const SignInSchema = Yup.object().shape({
  email: Yup.string()
    .email('Must be a valid email')
    .min(6)
    .required('Email is required'),
  password: Yup.string()
    .min(5, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Password Required'),
});

function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(state => state.auth.loading);
  const dLoading = useSelector(state => state.auth.loading);

  const params = new URLSearchParams(window.location.search);
  // const discountCode = params.get('discount_code');
  // const imageGeneration = params.get('image-generation');
  // const buyPlan = params.get('buy_plan');

  return (
    <Container>
      {/* <SalesBanner label={bannerText} /> */}
      <Fragment>
        <div className='container'>
          {/* Logo */}
          <div className='row sign__in-logo'>
            <div className='col-md-12'>
              <Link to='/'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='65'
                  height='92'
                  viewBox='0 0 65 92'
                  fill='none'
                >
                  <g clipPath='url(#clip0_61_1117)'>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M48.1196 33.6046L48.0851 33.6805L48.0895 33.6908C47.999 33.8859 47.6911 33.8263 47.6911 33.6107V28.4693L52.1572 24.2148C52.7063 24.4489 53.333 24.5454 53.9897 24.4694C55.4627 24.299 56.6319 23.2744 56.9226 21.8864C57.4093 19.5539 55.3011 17.5355 52.8549 17.9913C51.3949 18.2623 50.3161 19.3793 50.1352 20.7858C50.0555 21.4141 50.1567 22.0137 50.4022 22.5393L45.2082 27.4919V31.3377C45.2082 32.0502 44.5579 32.6005 43.8171 32.5143C42.973 32.4157 42.0858 32.3233 41.162 32.2412C40.9101 32.2186 40.6689 32.352 40.5677 32.5738L39.1917 35.5737C39.1012 35.7687 38.7933 35.7092 38.7933 35.4936V32.0564H38.789V22.6892L48.0141 13.8929C48.5654 14.129 49.192 14.2235 49.8509 14.1475C51.326 13.9771 52.4974 12.9484 52.7838 11.5583C53.2619 9.22577 51.1473 7.21354 48.701 7.67759C47.2453 7.95273 46.1686 9.06767 45.9899 10.4721C45.9102 11.0984 46.0114 11.6959 46.2569 12.2215L43.9011 14.4678L41.6594 12.3304C41.9372 11.7903 42.0621 11.1661 41.9846 10.5091C41.808 9.01634 40.6301 7.85417 39.0689 7.64268C36.8531 7.34085 34.971 9.0533 35.1325 11.1415C35.238 12.5193 36.2631 13.7122 37.6649 14.0613C38.4294 14.2502 39.1917 14.1865 39.8398 13.9381L42.1461 16.1372L36.3083 21.7037V30.6683C36.3083 31.3398 35.7225 31.8777 35.0184 31.851C34.4585 31.8285 33.8922 31.81 33.3172 31.7936C33.076 31.7853 32.8564 31.9188 32.7595 32.1282L30.6212 36.7872C30.5307 36.9822 30.2228 36.9227 30.2228 36.7071V6.34705C31.5127 5.87274 32.4257 4.67977 32.4257 3.28353C32.4257 1.34727 30.6664 -0.198858 28.5884 0.0208452C27.0875 0.178949 25.6899 1.5485 25.5564 2.98375C25.4164 4.5073 26.3596 5.83989 27.7421 6.34705V30.5636C27.7421 31.2084 27.2016 31.7361 26.5254 31.7484C25.4401 31.7689 24.2235 31.8018 23.627 31.8182C23.4009 31.8244 23.1984 31.9537 23.108 32.1529L21.5468 35.5572C21.4564 35.7523 21.1484 35.6928 21.1484 35.4772V31.9229H21.1441V21.6934L15.3063 16.1269L17.6126 13.9278C18.2629 14.1763 19.0252 14.242 19.7875 14.051C21.1872 13.702 22.2122 12.509 22.3199 11.1312C22.4814 9.04508 20.5993 7.33058 18.3835 7.63241C16.8223 7.8439 15.6422 9.00607 15.4678 10.4988C15.3903 11.1559 15.5152 11.7801 15.7929 12.3201L13.5513 14.4576L11.1955 12.2113C11.4409 11.6877 11.5422 11.0902 11.4625 10.4619C11.2816 9.0574 10.2071 7.94246 8.75137 7.66732C6.30297 7.20328 4.19049 9.21551 4.66854 11.548C4.95279 12.9402 6.12424 13.9668 7.59931 14.1393C8.25824 14.2153 8.88488 14.1188 9.43614 13.8847L18.6613 22.681V30.9907C18.6613 31.6067 18.166 32.12 17.5221 32.1714C16.0729 32.2884 14.7076 32.4301 13.4479 32.5902C13.2433 32.6149 13.0711 32.7422 12.9892 32.9208L12.6404 33.6826C12.5499 33.8797 12.242 33.8181 12.242 33.6025L12.2463 27.4816L12.242 27.4775L7.05234 22.5291C7.29998 22.0034 7.40119 21.4039 7.31937 20.7756C7.13633 19.3691 6.05748 18.2521 4.59964 17.981C2.15554 17.5252 0.0452216 19.5415 0.534041 21.8761C0.824748 23.2621 1.99404 24.2867 3.46695 24.4571C4.12374 24.5331 4.75037 24.4366 5.29949 24.2025L9.76561 28.4569V33.1652C6.39125 33.8202 4.37353 34.6476 4.37353 35.5511C4.37353 37.6578 15.3881 39.3682 28.9824 39.3682C42.5768 39.3682 53.5957 37.6557 53.5957 35.5511C53.5957 34.7031 51.8084 33.9167 48.7872 33.2822C48.5115 33.2247 48.2316 33.3582 48.1196 33.6046ZM57.4074 51.4289C58.0017 51.2276 58.6413 51.1168 59.3066 51.1168H59.3023C62.4463 51.1168 64.9959 53.5479 64.9959 56.5457C64.9959 59.5435 62.4463 61.9746 59.3023 61.9746C58.6391 61.9746 57.9974 61.8637 57.4031 61.6625V64.6336C57.4031 79.7479 44.5559 92.002 28.7005 92.002C12.8452 92.002 -0.00195312 79.7479 -0.00195312 64.6336V40.6203C-0.00195312 39.7436 0.956304 39.183 1.7789 39.5731C1.78536 39.5772 1.79828 39.5854 1.8112 39.5896C3.1786 40.2343 5.26954 40.8174 7.90959 41.3061C13.1359 42.2753 20.522 42.8789 28.7027 42.8789C36.8834 42.8789 44.2652 42.2753 49.4915 41.3061C52.1316 40.8195 54.2225 40.2363 55.5899 39.5896C55.5945 39.5878 55.5994 39.5853 55.6046 39.5827C55.6116 39.5792 55.6191 39.5755 55.6265 39.5731C56.4448 39.183 57.4074 39.7415 57.4074 40.6203V51.4289ZM14.5162 50.9546C11.2689 50.9546 8.63744 53.4637 8.63744 56.5601C8.63744 59.6605 11.2689 62.1697 14.5162 62.1697C17.7635 62.1697 20.3992 59.6564 20.3992 56.5601C20.3992 53.4637 17.7635 50.9546 14.5162 50.9546ZM28.9633 80.2551C35.895 80.2551 41.8104 76.1239 44.149 70.3007C44.6076 69.1611 43.4146 68.0585 42.2454 68.5513C38.1841 70.2658 33.6943 71.2185 28.9633 71.2185C24.2323 71.2185 19.7382 70.2658 15.6769 68.5513C14.5076 68.0585 13.3146 69.1632 13.7733 70.3007C16.1162 76.1239 22.0315 80.2551 28.9633 80.2551ZM37.0105 56.5601C37.0105 59.6605 39.6419 62.1697 42.8892 62.1697C46.1365 62.1697 48.7723 59.6564 48.7723 56.5601C48.7723 53.4637 46.1365 50.9546 42.8892 50.9546C39.6419 50.9546 37.0105 53.4596 37.0105 56.5601ZM57.4074 56.5436C57.4074 57.5456 58.2579 58.3567 59.3066 58.3567C60.3575 58.3567 61.2081 57.5456 61.2081 56.5436C61.2081 55.5416 60.3553 54.7347 59.3066 54.7347C58.2579 54.7347 57.4074 55.5416 57.4074 56.5436ZM14.5162 58.3731C15.567 58.3731 16.4176 57.56 16.4176 56.5601C16.4176 55.558 15.567 54.7511 14.5162 54.7511C13.4653 54.7511 12.6191 55.558 12.6191 56.5601C12.6191 57.5621 13.4653 58.3731 14.5162 58.3731ZM42.8892 58.3731C43.9401 58.3731 44.7907 57.56 44.7907 56.5601C44.7907 55.558 43.9379 54.7511 42.8892 54.7511C41.8405 54.7511 40.9899 55.558 40.9899 56.5601C40.9899 57.5621 41.8384 58.3731 42.8892 58.3731Z'
                      fill='white'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_61_1117'>
                      <rect width='65' height='92' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </div>
          </div>
          {/* BOX Container */}
          <div className='sign__in-box sign__up-box pt-4 mb-4'>
            <h1 className='account-heading'>Welcome Back</h1>
            <Formik
              initialValues={{ email: '', password: '' }}
              validationSchema={SignInSchema}
              onSubmit={(values, { setSubmitting }, errors) => {
                setTimeout(() => {
                  setSubmitting(false);
                }, 400);
                dispatch.auth.handleLogin({ data: values, navigate, errors });
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Input
                    type='email'
                    name='email'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    className='input-email mt-4'
                    placeholder='Email Address'
                    id='sign-in-email'
                  />
                  <ErrorMessage
                    error={errors.email && touched.email && errors.email}
                    left={true}
                  />
                  <InputPassword
                    type='password'
                    name='password'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    className='input-email mt-4'
                    placeholder='Password'
                    eye='true'
                    id='sign-in-password'
                  />
                  <ErrorMessage
                    error={
                      errors.password && touched.password && errors.password
                    }
                    left={true}
                  />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      width: '100%',
                    }}
                  >
                    <Link to='/forget-password' style={{ width: 'unset' }}>
                      <p className='forgot-password'>Forgot Password?</p>
                    </Link>
                  </div>
                  <Button
                    text={loading || dLoading ? <Spinner /> : 'Continue'}
                    className='account-button'
                    type='submit'
                    disabled={isSubmitting || loading}
                    id='sign-in-btn'
                  />
                </form>
              )}
            </Formik>
            <Divider>
              <span>or</span>
            </Divider>
            <GoogleLogin id='signin-with-google' isSignIn={true} />

            <p className='have-account mb-0'>
              Don't have an account?{' '}
              <Link to={`/sign-up?${params.toString()}`}>
                <span>signup</span>
              </Link>
            </p>
            <div className='account-bottom'>
              <p>{/* Terms of use <span>|</span> Privacy Policy */}</p>
            </div>
          </div>
        </div>
      </Fragment>
    </Container>
  );
}

export default SignIn;

const Divider = styled.div`
  width: 100%;
  margin-block: 30px;
  height: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ffffff1a;

  & span {
    color: ${({ theme }) => theme.colors.primary};
    line-height: 1;
    background-color: ${({ theme }) => theme.colors.darkbg};
    padding-inline: 10px;
    margin-top: -4px;
  }
`;

const Container = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
`;
